<template>
  <div>
    <v-dialog v-model="showAlertError" persistent width="500">
      <v-card>
        <v-card-title class="headline red accent-4" primary-title>
          {{ $t('presupuestos.error') }}
        </v-card-title>
        <v-card-text>
          {{ mensajeError }}
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <div class="flex-grow-1"></div>
          <v-btn color="primary" text @click="cerrarShowAlertError()">
            {{ $t('presupuestos.aceptar') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <h3>
      {{ $t('presupuestos.listaDePresupuestos') }}
      {{ `(${presupuestos.length})` }}
    </h3>

    <v-container v-if="!mostrarDatos">
      <span>{{ $t('presupuestos.noHayDatosParaMostrar') }}</span>
    </v-container>
    <v-container v-else grid-list-md text-xs-center>
      <v-row class="pb-0 mb-0" justify="center">
        <v-card outlined width="100%" class="mb-2 py-0">
          <v-col
            cols="12"
            sm="10"
            offset-sm="1"
            class="py-0 my-0"
            align-self="center"
          >
            <v-row class="py-2" justify="center">
              <v-col cols="12">
                <v-text-field
                  v-model="strBuscar"
                  append-icon="mdi-magnify"
                  outlined
                  clear-icon="mdi-close-circle"
                  clearable
                  :label="
                    inputFilterFocus
                      ? $t('presupuestos.filtro')
                      : $t(
                          'presupuestos.filtrarPorPresupuestoSiniestroCompaaSucursal'
                        )
                  "
                  :placeholder="
                    $t(
                      'presupuestos.filtrarPorPresupuestoSiniestroCompaaSucursal'
                    )
                  "
                  dense
                  hide-details
                  type="text"
                  @blur="inputFilterFocus = false"
                  @focus="inputFilterFocus = true"
                  @input="onChangeBuscar()"
                  @click:clear="clearBuscar"
                />
              </v-col>
            </v-row>
          </v-col>
        </v-card>
        <Loading
          v-if="showLoading"
          :mensaje="
            $t('presupuestos.esperandoResultadoDeLaPeticinPorFavorEspere')
          "
        />
      </v-row>
      <v-divider light></v-divider>
      <div v-for="item in presupuestos" :key="item.title">
        <v-layout row wrap py-1>
          <v-flex xs10 md9>
            <v-layout row wrap>
              <v-flex xs6 sm3 lg2 class="text-center">
                <div class="caption grey--text">
                  {{ $t('presupuestos.presupuesto') }}
                </div>
                <div
                  :class="$vuetify.breakpoint.smAndDown ? 'caption' : 'body-1'"
                >
                  {{ item.id }}
                </div>
              </v-flex>
              <v-flex xs6 sm3 lg2 class="text-center">
                <div class="caption grey--text">
                  {{ $t('presupuestos.siniestro') }}
                </div>
                <div
                  :class="$vuetify.breakpoint.smAndDown ? 'caption' : 'body-1'"
                >
                  {{ item.siniestro }}
                </div>
              </v-flex>
              <v-flex xs12 sm6 lg4>
                <div class="caption grey--text">
                  {{ $t('presupuestos.compania') }}
                </div>
                <div
                  :class="$vuetify.breakpoint.smAndDown ? 'caption' : 'body-1'"
                >
                  {{ item.aseguradora_nombre }}
                </div>
              </v-flex>
              <v-flex xs12 sm6 lg4>
                <div class="caption grey--text">
                  {{ $t('presupuestos.sucursal') }}
                </div>
                <div
                  :class="$vuetify.breakpoint.smAndDown ? 'caption' : 'body-1'"
                >
                  {{ item.sucursal }}
                </div>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs2 md3>
            <v-layout align-center justify-center row fill-height>
              <v-btn
                color="blue"
                class="hidden-sm-and-down white--text"
                @click="openPresupuesto(item.id, item.prestador_hash)"
              >
                <v-icon left dark>mdi-arrow-right</v-icon>
                {{ $t('presupuestos.ver') }}
              </v-btn>
              <v-btn
                small
                color="blue"
                class="hidden-md-and-up white--text"
                @click="openPresupuesto(item.id, item.prestador_hash)"
              >
                <v-icon left dark>mdi-arrow-right</v-icon>
              </v-btn>
            </v-layout>
          </v-flex>
        </v-layout>
        <v-divider light></v-divider>
      </div>
    </v-container>
    <div class="text-center">
      {{ $t('presupuestos.totalDeRegistros') }}
      <b>{{ presupuestos.length }}</b>
    </div>
  </div>
</template>
<script>
import Loading from '../Loading.vue'
import servicePresupuesto from '~/services/servicePresupuesto'

const URL_PRESUPUESTOS_COTIZAR = `PresupuestoWeb/cotizar`

export default {
  name: 'Presupuestos',
  components: { Loading },
  data() {
    return {
      user: {},
      datos: {},
      presupuestos: [],
      presupuestosSinFiltrar: [],
      mostrarDatos: true,
      showLoading: false,
      mensajeError: '',
      showAlertError: false,
      strBuscar: '',
      inputFilterFocus: false
    }
  },
  created() {
    this.getPresupuestos()
  },
  methods: {
    cerrarShowAlertError() {
      this.mensajeError = ''
      this.showAlertError = false
    },
    async getPresupuestos() {
      this.showLoading = true
      const payload = {
        status: [0, 1],
        tipo: 2
      }
      await servicePresupuesto
        .buscar(this.$config.axiosParams, payload)
        .then((response) => {
          this.showLoading = false
          this.presupuestos = Object.keys(response.data).map((p) => {
            return {
              ...response.data[p]
            }
          })
          this.presupuestosSinFiltrar = this.presupuestos
        })
        .catch((error) => {
          if (error?.response?.status === 401) {
            this.$router.push('/login')
          } else {
            this.mostrarDatos = false
            this.showLoading = false
            this.mensajeError = `Error al obtener los presupuestos. ${error}`
            this.showAlertError = true
          }
        })
    },
    openPresupuesto(presupuestoId, prestadorHash) {
      window.open(
        `${this.$config.axiosParams.baseURL}/${URL_PRESUPUESTOS_COTIZAR}/${prestadorHash}/${presupuestoId}`,
        '_blank'
      )
    },
    onChangeBuscar() {
      if (this.strBuscar) {
        this.strBuscar = this.strBuscar.trim()
      }
      if (this.strBuscar === '') {
        this.presupuestos = this.presupuestosSinFiltrar
      }
      if (this.strBuscar !== null && this.strBuscar !== '') {
        if (Object.keys(this.presupuestos).length === 0) {
          this.presupuestos = this.presupuestosSinFiltrar
        }
        this.presupuestos = this.presupuestos.filter((c) => {
          const strABuscar = this.strBuscar.toLowerCase()
          return (
            c.id.toLowerCase().includes(strABuscar) ||
            c.siniestro.toLowerCase().includes(strABuscar) ||
            c.aseguradora_nombre.toLowerCase().includes(strABuscar) ||
            c.sucursal.toLowerCase().includes(strABuscar)
          )
        })
      }
    },
    clearBuscar() {
      this.strBuscar = ''
      this.presupuestos = this.presupuestosSinFiltrar
    }
  }
}
</script>
